import { FilterTag } from './filter-tag';
import { emptySidebarStyles } from './styles';
import type { SuggestionProps } from './types';

export function SuggestionStatus({ blindingFilters }: SuggestionProps) {
  const style = emptySidebarStyles();

  if (blindingFilters.alertStatusList.neitherSelected) {
    return (
      <div className={style.suggestion()}>
        <span>
          Enable both <FilterTag text="Critical" /> and{' '}
          <FilterTag text="Warning" /> to see all relevant alerts.
        </span>
      </div>
    );
  }

  if (blindingFilters.alertStatusList.onlyWarningSelected) {
    return (
      <div className={style.suggestion()}>
        <span>
          Enable <FilterTag text="Critical" /> so you don't miss high-priority
          issues.
        </span>
      </div>
    );
  }

  if (blindingFilters.alertStatusList.onlyCriticalSelected) {
    return (
      <div className={style.suggestion()}>
        <span>
          Enable the <FilterTag text="Warning" /> filter to lower-priority
          alerts that may still be important.
        </span>
      </div>
    );
  }

  return null;
}
